export const questions = [
    {
        question: "كيف يمكنني الاشتراك في خدمات الموقع؟",
        answer: "يمكنك الاشتراك بسهولة من خلال زيارة صفحة التسجيل، اختيار خطتك المفضلة، وإتمام عملية الدفع عبر وسائل الدفع المتاحة."
    },
    {
        question: "ما هي طرق الدفع المتاحة؟",
        answer: "يوجد طريقتان للدفع اما عن طريق حسابك البنكي (البطاقه) او عن طريق محفظتك الالكترونيه"
    },
    {
        question: "هل يمكنني تغيير أو إلغاء اشتراكي؟",
        answer: "يمكنك التواصل معنا عن طريق صفحه التواصل او عن طريق حجز موعد استشاره معنا لتغيير خطتك"
    },
    {
        question: "كيف يمكنني التواصل مع المدربين؟",
        answer: "عن طريق حجز استشاره او موعد مع او عن طريق مواقع التواصل الخاصه"
    }
]